import { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { wacToken } from "@/libraries/design/foundations/index.ts";

export interface GenericTableColumnHeaderProps
    extends HTMLAttributes<HTMLTableCellElement> {
    colWidth?: string;
}

const headCellCss = css({
    "fontWeight": 700,
    "textAlign": "left",
    "color": wacToken("color.primary.black"),
    "display": "table-cell",
    "padding": "14px",
    "borderInlineEnd": `1px solid ${wacToken("color.neutral.light400")}`,
    ":last-of-type": {
        borderInlineEnd: "none"
    },
    [media.below.sm]: {
        display: "none"
    }
});

export const GenericTableColumnHeader = ({
    colWidth,
    style,
    ...props
}: GenericTableColumnHeaderProps) => {
    return (
        <th
            {...props}
            css={headCellCss}
            scope="col"
            style={{
                width: colWidth ?? "var(--generic-table-col-width)",
                ...style
            }}
        />
    );
};
